import type { Lane } from "@/lib/track/lane";
import type { Controler, LaneOrigin } from "@/lib/track/controler/controler";

export type ColorToken = "hand.right" | "hand.left" | "live" | "default";

export type LaneView = {
  readonly lane: Lane;
  readonly origin: LaneOrigin;
  readonly colorToken: ColorToken;
};

function originToColorToken(origin: LaneOrigin): ColorToken {
  if (origin.kind === 'song-part') {
    if (origin.hand === 'right') {
      return 'hand.right';
    }

    if (origin.hand === 'left') {
      return 'hand.left';
    }

    return 'default';
  }

  if (origin.kind === 'live-piano' || origin.kind === 'live-peer') {
    return 'live';
  }

  return 'default';
}

export function buildLaneView(lane: Lane, controler: Controler): LaneView {
  const origin: LaneOrigin = controler.getLaneOrigin?.(lane) ?? { kind: 'other' };

  return {
    lane,
    origin,
    colorToken: originToColorToken(origin),
  };
}
